import { Alert, Box, Group } from "@mantine/core";
import { AlertPresets } from "../../../../../mantine/mantinePresets";
import type { Todo } from "../../../../../utils/backend-types";
import { getErrorText } from "../../../../../utils/get-error-text";
import { useTodoCanGenerateDocuments } from "../../../hooks/useTodoCanGenerateDocuments";
import type { Mode } from "../../../Todos.types";
import { GenerateDocumentsButton } from "./GenerateDocumentsButton/GenerateDocumentsButton";
import { GenerateProformaDocumentsButton } from "./GenerateDocumentsButton/GenerateProformaButton";

export interface GenerateDocumentsProps {
  todoId: number;
  todoLabel: string;
  storeTodo: (todo: Todo) => void;
  reloadTodo: () => void;
  handleErrorMessage: (message: string) => void;
  mode: Mode;
  variantId: number;
}

function GenerateDocuments({
  todoId,
  todoLabel,
  storeTodo,
  handleErrorMessage,
  mode,
  variantId
}: GenerateDocumentsProps) {
  const { todoCanGenerateDocuments, todoCanGenerateDocumentsError } =
    useTodoCanGenerateDocuments(todoId, handleErrorMessage);

  const {
    can_generate_documents_automatically,
    can_generate_proforma_documents
  } = todoCanGenerateDocuments ?? {};

  return (
    <Box className="GenerateDocuments">
      {todoCanGenerateDocumentsError && (
        <Alert
          color={AlertPresets.error.color}
          icon={AlertPresets.error.icon}
          mb="md"
        >
          {getErrorText(todoCanGenerateDocumentsError)}
        </Alert>
      )}
      <Group gap="xs" justify="center">
        <GenerateDocumentsButton
          disabled={!can_generate_documents_automatically}
          todoId={todoId}
          todoLabel={todoLabel}
          onUpdateTodo={storeTodo}
        />
        {!!can_generate_proforma_documents && (
          <GenerateProformaDocumentsButton
            disabled={!can_generate_proforma_documents}
            mode={mode}
            todoId={todoId}
            variantId={variantId}
          />
        )}
      </Group>
    </Box>
  );
}

export { GenerateDocuments };
